import {
  Directive,
  EventEmitter,
  HostListener,
  Injector,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogContainerComponent } from '@libs/shared/ui/dialog-container/dialog-container.component';
import { ShortcutHelpComponent } from '@libs/shared/ui/shortcut-help-dialog/shortcut-help.component';

@Directive({
  selector: '[appHelpShortcutDialogTrigger]',
  standalone: true,
})
export class ShortcutHelpDialogTriggerDirective {
  @Output() dialogClosed = new EventEmitter<any>();

  constructor(
    private dialog: MatDialog,
    private injector: Injector
  ) {}

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DialogContainerComponent, {
      minWidth: '600px',
      panelClass: 'custom-dialog-container',
      data: {
        title: '단축키 목록',
        component: ShortcutHelpComponent,
        injector: this.injector,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.dialogClosed.emit(result);
    });
  }
}
